import * as React from "react";
import { connect } from "react-redux";

import Support from "../../screens/Support";
import {

  fetchSupportType,
  supportList,
  SupportSelectedPage,
  SupportHistorySelectedPage,
  editSupport,
  addSupportHistory,
  fetchSupportHistory,
  fetchSupportUsers
} from "./action";
class SupportContainer extends React.Component<Props, State> {
  render() {
    return (
      <Support
        fetchSupportType={this.props.fetchSupportType}
        supportTypeList={this.props.supportTypeList}
        supportList={this.props.supportList}
        supportDtlsList={this.props.supportDtlsList}
        supportDtlsCount={this.props.supportDtlsCount}
        SupportSelectedPage={this.props.SupportSelectedPage}
        SupportHistorySelectedPage={this.props.SupportHistorySelectedPage}
        supportUsersList={this.props.supportUsersList}
        editSupport={this.props.editSupport}
        addSupportHistory={this.props.addSupportHistory}
        fetchSupportHistory={this.props.fetchSupportHistory}
        fetchSupportUsers={this.props.fetchSupportUsers}
        supportHistoryList={this.props.supportHistoryList}
        supportHistoryCount={this.props.supportHistoryCount}
      />
    );
  }
}

function bindAction(dispatch) {
  return {
    fetchSupportType: () => {
      dispatch(fetchSupportType());
    },
    supportList: (value)=> {
      dispatch(supportList(value));
    },
    SupportSelectedPage: value => {
      dispatch(SupportSelectedPage(value));
    },
    SupportHistorySelectedPage: value => {
      dispatch(SupportHistorySelectedPage(value));
    },
    editSupport: value => {
      dispatch(editSupport(value));
    },
    addSupportHistory: value => {
      dispatch(addSupportHistory(value));
    },
    fetchSupportHistory: value => {
      dispatch(fetchSupportHistory(value));
    },
    fetchSupportUsers: () => {
      dispatch(fetchSupportUsers());
    },
  };
}
function mapStateToProps(state) {
  return {
    supportDtlsList: state.SupportReducer.supportDtlsList,
    supportTypeList: state.SupportReducer.supportTypeList,
    supportDtlsCount: state.SupportReducer.supportDtlsCount,
    supportHistoryList: state.SupportReducer.supportHistoryList,
    supportHistoryCount: state.SupportReducer.supportHistoryCount,
    supportUsersList: state.SupportReducer.supportUsersList
  };
};

export default connect(
  mapStateToProps,
  bindAction
)(SupportContainer);
